// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChevronLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.4497471,5 L12.8639603,6.41421413 L9.32842731,9.94974709 L12.8639622,13.485281 L11.4497471,14.8994951 L6.5,9.94974709 L11.4497471,5 Z M20,10 C20,15.5228472 15.5228472,20 10,20 C4.47715235,20 0,15.5228472 0,10 C0,4.47715235 4.47715235,0 10,0 C15.5228472,0 20,4.47715235 20,10 C20,13.6818981 20,13.6818981 20,10 Z M18,10 C18,14.4182777 14.4182777,18 10,18 C5.58172178,18 2,14.4182777 2,10 C2,5.58172178 5.58172178,2 10,2 C14.4182777,2 18,5.58172178 18,10 C18,12.9455185 18,12.9455185 18,10 Z"
            />
        </svg>
    );
};

export default React.memo(ChevronLeft);
